/* tj-home.js — Inicio TUS JERSEYS: escalera de precios, grid Top 10, "Arma tu pedido" y carrito */
(function () {
  'use strict';
  var root = document.querySelector('[data-tj-home]');
  if (!root) return;
  var C;
  try { C = JSON.parse(root.querySelector('script[data-tj-config]').textContent); } catch (e) { console.error('[TJ] config', e); return; }

  var num = function (x) { return parseFloat(String(x).replace(/[^0-9.]/g, '')) || 0; };
  var niveles = C.niveles.map(num).filter(function (n) { return n > 0; });
  var nombres = C.nombres.map(function (x) { return String(x).trim(); });
  var precios = { fan: C.precios.fan.map(num), player: C.precios.player.map(num) };
  var TALLAS = C.tallas.map(function (x) { return String(x).trim(); }).filter(Boolean);
  var VERS = ['fan', 'player'];
  var curva = {};
  String(C.curva || 'S:15,M:30,L:30,XL:15,2XL:10').split(',').forEach(function (kv) { var p = kv.split(':'); if (p[0] && p[0].trim()) curva[p[0].trim()] = num(p[1]); });
  function distribute(n) {
    var sizes = TALLAS.filter(function (t) { return curva[t] > 0; }), sum = sizes.reduce(function (a, t) { return a + curva[t]; }, 0) || 1;
    var raw = sizes.map(function (t) { return { t: t, v: n * curva[t] / sum }; }), out = {};
    raw.forEach(function (r) { out[r.t] = Math.floor(r.v); });
    var rest = n - raw.reduce(function (a, r) { return a + Math.floor(r.v); }, 0);
    raw.slice().sort(function (a, b) { return (b.v % 1) - (a.v % 1); }).forEach(function (r) { if (rest > 0) { out[r.t]++; rest--; } });
    return out;
  }
  var HEAD_BG = ['#E9EAEC', '#DCEDE3', '#E6E0F3', '#DCE8F4', '#F3E8CE', '#F0DFDB'];
  var HEAD_FG = ['#3F4450', '#2E5B40', '#4B3F78', '#2F4F74', '#6A5220', '#7A3E34'];

  var models = (C.models || []).map(function (m) {
    var v = { fan: {}, player: {} };
    (m.vars || []).forEach(function (x) { if (!v[x.ver]) v[x.ver] = {}; v[x.ver][x.t] = x.id; });
    m.v = v; return m;
  });
  var byHandle = {}; models.forEach(function (m) { byHandle[m.handle] = m; });

  var KEY = 'tj-mayoreo-qty';
  var S = { qty: {}, sel: 0, open: false, ver: 'fan', pastHero: false };
  try { S.qty = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { S.qty = {}; }
  Object.keys(S.qty).forEach(function (k) { if (!byHandle[k.split('|')[0]]) delete S.qty[k]; });
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(S.qty)); } catch (e) {} }

  var $ = function (sel) { return root.querySelector(sel); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
  function totalOf() { var s = 0; for (var k in S.qty) s += S.qty[k]; return s; }
  function tierOf(t) { var i = 0; niveles.forEach(function (n, k) { if (t >= n) i = k; }); return i; }
  function priceOf(v, tier) { var a = precios[v]; return a[Math.min(tier, a.length - 1)]; }
  function rango(i) { var min = niveles[i], nx = niveles[i + 1]; return nx ? min + '–' + (nx - 1) + ' pz' : min + '+ pz'; }
  function imgTag(src, alt, fit) { return src ? '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" class="tj-img-fill" style="object-fit:' + (fit || 'cover') + '" loading="lazy">' : ''; }
  var check = '<svg width="11" height="11" viewBox="0 0 12 12"><path d="M2.5 6.2l2.4 2.3 4.6-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var toastT;
  function toast(msg) { var t = $('[data-tj-toast]'); t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 3200); }

  function calc() {
    var total = totalOf(), tier = tierOf(total), sub = 0, last = niveles.length - 1;
    for (var k in S.qty) { var v = k.split('|')[1]; sub += S.qty[k] * priceOf(v, tier); }
    var msg, short, pct, tierMsg;
    if (tier < last) {
      var nx = niveles[tier + 1], base = (total === 0 || tier === 0) ? 0 : niveles[tier], faltan = nx - total, np = fmt(priceOf(S.ver, tier + 1));
      pct = Math.max(0, Math.min(100, Math.round((total - base) / (nx - base) * 100)));
      msg = 'Agrega ' + faltan + ' ' + (faltan === 1 ? 'pieza' : 'piezas') + (total ? ' más' : '') + ' y baja a ' + np + ' c/u';
      short = '+' + faltan + ' pz → ' + np + ' c/u';
      tierMsg = 'Agrega ' + faltan + ' pz' + (total ? ' más' : '') + ' para subir a ' + (nombres[tier + 1] || 'siguiente nivel');
    } else { pct = 100; msg = 'Nivel máximo: cotiza por WhatsApp tu mejor precio'; short = 'Nivel máximo'; tierMsg = 'Estás en ' + (nombres[tier] || 'el nivel máximo') + ': tu mejor precio'; }
    return { total: total, tier: tier, sub: sub, msg: msg, short: short, pct: pct, tierMsg: tierMsg };
  }

  function renderLadder(c) {
    $('[data-tj-tiermsg]').textContent = c.tierMsg;
    root.querySelectorAll('.tj-vt').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === S.ver)); });
    $('[data-tj-ladder]').innerHTML = niveles.map(function (n, i) {
      var act = i === c.tier && c.total > 0, next = c.total === 0 ? i === 1 : i === c.tier + 1;
      var estado = act ? 'Tu nivel' : next ? 'Siguiente rango' : 'Por alcanzar';
      var off = Math.round((1 - priceOf(S.ver, i) / precios[S.ver][0]) * 100), best = i === niveles.length - 1;
      return '<div class="tj-lv" data-active="' + act + '" data-best="' + best + '">' + (best ? '<span class="tj-lv__best">MEJOR PRECIO</span>' : '') + '<div class="tj-lv__n" style="background:' + HEAD_BG[i % 6] + ';color:' + HEAD_FG[i % 6] + '">' + esc(nombres[i] || ('Nivel ' + (i + 1))) + '</div>' + (off > 0 ? '<span class="tj-lv__off">-' + off + '%</span>' : '<span class="tj-lv__off tj-lv__off--0">precio base</span>') +
        '<div class="tj-lv__r">' + rango(i) + '</div><div class="tj-lv__p">' + fmt(priceOf(S.ver, i)) + '</div><div class="tj-lv__c">c/u</div>' +
        (act ? '<span class="tj-lv__s"><i></i>' + estado + '</span>' : '') + '</div>';
    }).join('');
  }

  function renderGrid() {
    var p1 = fmt(priceOf(S.ver, 0)) + ' MXN';
    root.querySelectorAll('[data-tj-p1]').forEach(function (e) { e.textContent = p1; });
    var fromP = 'Mayoreo desde ' + fmt(priceOf(S.ver, niveles.length - 1));
    root.querySelectorAll('[data-tj-from]').forEach(function (e) { e.textContent = fromP; });
    root.querySelectorAll('.tj-card__s').forEach(function (e, i) { if (models[i]) e.textContent = '🔥 ' + Number(models[i].sold || 0).toLocaleString('es-MX') + ' vendidas'; });
    root.querySelectorAll('[data-tj-in]').forEach(function (e) {
      var h = e.getAttribute('data-tj-in'), pz = 0;
      Object.keys(S.qty).forEach(function (k) { if (k.indexOf(h + '|') === 0) pz += S.qty[k]; });
      e.hidden = !pz; e.textContent = 'En tu pedido: ' + pz + ' pz';
    });
  }

  function renderSheet(c) {
    var el = $('[data-tj-armar]');
    el.hidden = !S.open; document.body.classList.toggle('tj-lock', S.open);
    if (!S.open) return;
    var m = models[S.sel] || models[0]; if (!m) return;
    var img = $('[data-tj-aimg]');
    img.innerHTML = (m.img ? imgTag(m.img, m.title) : '<span class="tj-ph">FOTO · ' + esc(m.title) + '</span>') +
      (m.badge ? '<span class="tj-badge" data-express="' + !!m.express + '">' + esc(m.badge) + '</span>' : '');
    $('[data-tj-aname]').textContent = m.title;
    $('[data-tj-arank]').textContent = '#' + (S.sel + 1) + ' · 🔥 ' + Number(m.sold || 0).toLocaleString('es-MX') + ' vendidas';
    $('[data-tj-aprice]').textContent = fmt(priceOf(S.ver, c.tier)) + ' MXN';
    $('[data-tj-amen]').textContent = priceOf(S.ver, c.tier) < precios[S.ver][0] ? fmt(precios[S.ver][0]) + ' MXN' : '';
    $('[data-tj-acount]').textContent = models.length + ' DISPONIBLES';
    $('[data-tj-asel]').textContent = m.title;
    var ms = $('[data-tj-amodels]'), sl = ms.scrollLeft;
    ms.innerHTML = models.map(function (x, i) {
      var sel = i === S.sel;
      return '<button type="button" class="tj-mcard" data-act="hpick" data-i="' + i + '" aria-pressed="' + sel + '" aria-label="' + esc(x.title) + '">' +
        '<div class="tj-mcard__box"><div class="tj-mcard__in tj-stripes">' + imgTag(x.thumb, '', 'contain') + '</div><span class="tj-rank">#' + (i + 1) + '</span><span class="tj-check">' + check + '</span></div>' +
        '<span class="tj-mcard__n">' + esc(x.title) + '</span></button>';
    }).join('');
    ms.scrollLeft = sl;
    $('[data-tj-avers]').innerHTML = VERS.map(function (v) {
      return '<button type="button" class="tj-ver" data-act="hver" data-v="' + v + '" aria-pressed="' + (v === S.ver) + '">' + esc(C.versiones[v]) + ' · ' + fmt(priceOf(v, c.tier)) + '</button>';
    }).join('');
    var rows = $('[data-tj-arows]'), a = document.activeElement, fk = a && rows.contains(a) && a.tagName === 'INPUT' ? a.dataset.hk : null;
    rows.innerHTML = TALLAS.map(function (t) {
      var k = m.handle + '|' + S.ver + '|' + t, n = S.qty[k] || 0;
      return '<div class="tj-row"><div class="tj-row__img">' + imgTag(m.thumb, '', 'contain') + '</div><div class="tj-row__t">' + esc(t) + '</div>' +
        '<div class="tj-stepper" role="group" aria-label="Cantidad talla ' + esc(t) + '">' +
        '<button type="button" data-act="hdec" data-k="' + esc(k) + '" aria-label="Quitar una pieza talla ' + esc(t) + '">–</button>' +
        '<input type="text" inputmode="numeric" pattern="[0-9]*" aria-label="Piezas talla ' + esc(t) + '" value="' + n + '" data-hk="' + esc(k) + '">' +
        '<button type="button" data-act="hinc" data-k="' + esc(k) + '" aria-label="Agregar una pieza talla ' + esc(t) + '">+</button></div></div>';
    }).join('');
    if (fk) { var e = rows.querySelector('input[data-hk="' + CSS.escape(fk) + '"]'); if (e) e.focus(); }
    var qa = $('[data-tj-aquick]');
    if (qa) qa.innerHTML = '<span>Surtido rápido de ' + esc(m.title) + ':</span>' + [6, 12, 24].map(function (n) { return '<button type="button" data-act="hsurt" data-n="' + n + '">+' + n + ' pz</button>'; }).join('');
    $('[data-tj-atotal]').textContent = c.total;
    $('[data-tj-amsg]').innerHTML = esc(c.msg) + ' · <span>' + fmt(priceOf(S.ver, c.tier)) + ' c/u</span> hoy';
    var per = {}, order = [];
    Object.keys(S.qty).forEach(function (k) { var h = k.split('|')[0]; if (!per[h]) { per[h] = 0; order.push(h); } per[h] += S.qty[k]; });
    var ln = $('[data-tj-alines]');
    ln.hidden = !order.length;
    ln.innerHTML = 'Tu pedido: ' + order.map(function (h) { return esc(byHandle[h].title) + ' <b>' + per[h] + ' pz</b>'; }).join(' · ');
    var fb = root.querySelector('.tj-armar__foot [data-act="haddall"]');
    fb.setAttribute('data-empty', String(!c.total));
    $('[data-tj-afoot]').textContent = c.total ? c.total + ' pz · ' + fmt(c.sub) : 'Elige tallas';
  }

  function renderBar(c) {
    var empty = c.total === 0;
    var on = !S.open && (c.total > 0 || S.pastHero);
    $('[data-tj-bar]').setAttribute('data-empty', String(empty));
    var bl = $('[data-tj-blabel]'); if (bl) bl.textContent = empty ? 'Arma tu pedido' : 'Agregar todo al carrito';
    $('[data-tj-bar] .tj-sticky__b').setAttribute('data-act', empty ? 'openfirst' : 'haddall');
    $('[data-tj-bar]').hidden = !on; document.body.classList.toggle('tj-has-bar2', on);
    $('[data-tj-bprog]').style.width = c.pct + '%';
    $('[data-tj-bshort]').textContent = c.short;
    $('[data-tj-bsum]').textContent = empty ? 'desde ' + fmt(priceOf(S.ver, niveles.length - 1)) + ' c/u' : c.total + ' pz · ' + fmt(c.sub);
    $('[data-tj-bshort]').textContent = empty ? 'Todo suma para tu descuento' : c.short;
    var b = $('[data-tj-bubble]'); if (b) b.hidden = S.open;
  }

  function render() { var c = calc(); renderLadder(c); renderGrid(); renderSheet(c); renderBar(c); }
  function commit(before) {
    save(); render();
    var t0 = tierOf(before), t1 = tierOf(totalOf());
    if (t1 > t0 && totalOf() > 0) {
      toast('🎉 Subiste a ' + (nombres[t1] || 'otro nivel') + ': ' + fmt(priceOf(S.ver, t1)) + ' c/u');
      root.querySelectorAll('.tj-armar__foot .tj-sticky__b, [data-tj-bar] .tj-sticky__b').forEach(function (b) { b.classList.remove('tj-bump'); void b.offsetWidth; b.classList.add('tj-bump'); });
    }
  }
  function setQty(k, n) { var before = totalOf(); n = Math.max(0, Math.min(9999, parseInt(n, 10) || 0)); if (n) S.qty[k] = n; else delete S.qty[k]; commit(before); }
  function surtido(n) {
    var m = models[S.sel]; if (!m) return;
    var before = totalOf(), d = distribute(n);
    Object.keys(d).forEach(function (t) { if (d[t]) { var k = m.handle + '|' + S.ver + '|' + t; S.qty[k] = (S.qty[k] || 0) + d[t]; } });
    commit(before);
  }
  window.TJHome = {
    niveles: niveles, nombres: nombres, precios: precios,
    open: function (i, n) { S.sel = Math.max(0, Math.min(models.length - 1, i || 0)); S.open = true; render(); if (n) surtido(n); }
  };

  async function addAll() {
    var total = totalOf();
    if (!total) { toast('Elige al menos una talla con el botón +'); if (!S.open) { S.open = true; render(); } return; }
    var missing = 0, items = Object.keys(S.qty).map(function (k) {
      var p = k.split('|'), m = byHandle[p[0]], id = m && m.v[p[1]] && m.v[p[1]][p[2]];
      if (!id) missing++;
      return { id: id, quantity: S.qty[k] };
    });
    if (missing) { toast('Falta la variante de ' + missing + ' combinación(es). Revisa las opciones Versión/Talla del producto.'); return; }
    var btns = root.querySelectorAll('[data-act="haddall"]'); btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    try {
      var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!res.ok) throw new Error('cart/add ' + res.status);
      S.qty = {}; save(); (window.TJ_go || function (u) { location.href = u; })(C.cartUrl || '/cart');
    } catch (e) { console.error('[TJ]', e); toast('No se pudo agregar. Intenta de nuevo o escríbenos por WhatsApp.'); btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]'); if (!t) return;
    var a = t.getAttribute('data-act');
    if (a === 'hclose' && t.hasAttribute('data-tj-armar') && e.target.closest('[data-stop]')) return;
    switch (a) {
      case 'openfirst': e.preventDefault(); S.sel = 0; S.open = true; render(); break;
      case 'hopen': S.sel = +t.dataset.i; S.open = true; render(); break;
      case 'hclose': S.open = false; render(); break;
      case 'hpick': S.sel = +t.dataset.i; render(); break;
      case 'hver': S.ver = t.dataset.v; render(); break;
      case 'hdec': setQty(t.dataset.k, (S.qty[t.dataset.k] || 0) - 1); break;
      case 'hinc': setQty(t.dataset.k, (S.qty[t.dataset.k] || 0) + 1); break;
      case 'haddall': addAll(); break;
      case 'hsurt': surtido(+t.dataset.n); break;
    }
  });
  document.addEventListener('change', function (e) { var i = e.target; if (i.dataset && i.dataset.hk) setQty(i.dataset.hk, String(i.value).replace(/\D/g, '')); });
  document.addEventListener('focusin', function (e) { var i = e.target; if (i.dataset && i.dataset.hk) i.select(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.open) { S.open = false; render(); }
    var i = e.target; if (e.key === 'Enter' && i.dataset && i.dataset.hk) i.blur();
  });

  var hero = document.querySelector('.tj-hero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { S.pastHero = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; renderBar(calc()); }).observe(hero);
  }
  render();
})();
